"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isContentCategoriesProperty = exports.contentCategoriesPropertyDefinition = void 0;
exports.contentCategoriesPropertyDefinition = {
    view: {
        label: 'Custom tags',
        style: 'tag',
        hint: 'Tags you requested to group serialised content.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['content-category'],
        },
    ],
    type: 'asset',
    multiple: true,
    name: 'content-categories',
};
const isContentCategoriesProperty = (prop) => {
    return prop.name === exports.contentCategoriesPropertyDefinition.name;
};
exports.isContentCategoriesProperty = isContentCategoriesProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGVudC1jYXRlZ29yaWVzLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvY29udGVudC1jYXRlZ29yaWVzLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsbUNBQW1DLEdBQUc7SUFDakQsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGFBQWE7UUFDcEIsS0FBSyxFQUFFLEtBQUs7UUFDWixJQUFJLEVBQUUsaURBQWlEO0tBQ3hEO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsQ0FBQyxrQkFBa0IsQ0FBQztTQUMvQjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxvQkFBb0I7Q0FDSyxDQUFBO0FBSTFCLE1BQU0sMkJBQTJCLEdBQUcsQ0FBQyxJQUFrQixFQUFxQyxFQUFFO0lBQ25HLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSywyQ0FBbUMsQ0FBQyxJQUFJLENBQUE7QUFDL0QsQ0FBQyxDQUFBO0FBRlksUUFBQSwyQkFBMkIsK0JBRXZDIn0=